import Api from '@/api/api.js'

export default {
    
    /**
     * Route pour recuperer les bons commandes  
     */
    echanges () {
        const promise = Api().get('/echanges')
        return promise.then((response) => response.data)
    },

    /**
     * Enregistrer un echange
     * @param object data 
     */
    saveEchange (data) {
        const promise = Api().post('/echange', data)
        return promise.then((response) => response.data)
    },

    /**
     * Enregistrer un bon de commandes
     * @param object id
     */
    getEchange (id) {
        const promise = Api().get('/echanges/'+id)
        return promise.then((response) => response.data)
    }


  }